import { useLingui } from '@lingui/react/macro'

import { DialogHeader } from '@/layouts/Dialog'
import { BillingForm } from '@/features/billing'
import { useCloseModal } from '@/Router'
import { Suspense } from '@/components/ui/Suspense'

function OrganizationBilling() {
  const { t } = useLingui()
  const closeModal = useCloseModal()

  return (
    <div className="flex flex-col p-8">
      <DialogHeader
        title={t`Billing`}
        description={t`Edit Billing of your Hotel`}
      />
      <BillingForm onDone={closeModal} />
    </div>
  )
}

export default function OrganizationBillingSuspense() {
  return (
    <Suspense isDialog>
      <OrganizationBilling />
    </Suspense>
  )
}
